import Vue from 'vue'
import moment from 'moment'

Vue.filter('monthName', (value, format = 'MMMM') => {
  return value ? moment(value).locale('pt-br').format(format) : ''
})
